export const START = 'START';
export const GUESSING = 'GUESSING';
export const SEE_RESAULT = 'SEE_RESAULT';
